import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

const PriceSection = () => {
  const { t, language } = useLanguage();

  return (
    <section 
      className="py-16 md:py-20 bg-[#1A2F23]"
      data-testid="price-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex flex-col md:flex-row items-center justify-between gap-8"
        >
          {/* Left - Price */}
          <div className="text-center md:text-left">
            <p className="text-[#C5A059] text-sm uppercase tracking-[0.2em] mb-2">
              {language === 'fr' ? 'Prix de Vente' : 'Asking Price'}
            </p>
            <p 
              className="text-white text-5xl md:text-6xl lg:text-7xl font-['Playfair_Display'] tracking-tight"
              data-testid="price-display"
            >
              2 495 000 €
            </p>
          </div>

          {/* Right - Key Stats */}
          <div className="flex flex-wrap justify-center md:justify-end gap-8 md:gap-12">
            <div className="text-center">
              <p className="text-white text-3xl md:text-4xl font-['Playfair_Display']">342 m²</p>
              <p className="text-white/60 text-xs uppercase tracking-widest mt-1">
                {language === 'fr' ? 'Au sol' : 'Floor Area'}
              </p>
            </div>
            <div className="text-center">
              <p className="text-white text-3xl md:text-4xl font-['Playfair_Display']">1 063 m²</p>
              <p className="text-white/60 text-xs uppercase tracking-widest mt-1">
                {language === 'fr' ? 'Terrain' : 'Land'}
              </p>
            </div>
            <div className="text-center">
              <p className="text-white text-3xl md:text-4xl font-['Playfair_Display']">5</p>
              <p className="text-white/60 text-xs uppercase tracking-widest mt-1">
                {language === 'fr' ? 'Chambres' : 'Bedrooms'}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PriceSection;
